module.exports = __webpack_public_path__ + "static/media/kualaLumpur-gray.53f5a20a.svg";